module.exports = __webpack_public_path__ + "static/20230619_058-46b388d24c94272479901d42e66f2025.jpg";